import React, { useState, useEffect } from "react";
import axios from "axios";
import Descargar from "../../assets/img/Descarga.png";

const API_URL = process.env.REACT_APP_API_URL || "";

const GenerarCertificado = () => {
  const [error, setError] = useState(null);
  const [nombreUsuario, setNombreUsuario] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No se encontró el token de autenticación");
        }

        const response = await axios.get(`${API_URL}/api/usuarios/perfil`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { nombre, apellidos } = response.data || {};
        const nombreCompleto = `${nombre ?? ""} ${apellidos ?? ""}`
          .replace(/\s+/g, " ")
          .trim();

        setNombreUsuario(nombreCompleto);
      } catch (error) {
        console.error("Error al obtener datos del usuario:", error);
        setError("Error al obtener datos del usuario");
      }
    };

    fetchUserData();
  }, []);

  const generarCertificado = async () => {
    try {
      setError(null);
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No se encontró el token de autenticación");
      }

      console.log("Datos enviados:", { nombreUsuario });

      const response = await axios({
        method: "post",
        url: `${API_URL}/api/certificado/generar`,
        data: { nombreUsuario },
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "image/png",
        },
      });

      console.log("Respuesta recibida:", response);
      console.log("Tipo de contenido:", response.headers["content-type"]);

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "image/png" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `certificado_${nombreUsuario.replace(/\s+/g, "_")}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        console.log("Descarga iniciada");
      } else {
        throw new Error("Error al generar la constancia");
      }
    } catch (error) {
      console.error("Error detallado:", error.response || error);
      if (error.response && error.response.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          const errorMessage = reader.result;
          setError(`Error al generar la constancia: ${errorMessage}`);
        };
        reader.readAsText(error.response.data);
      } else {
        setError(`Error al generar la constancia: ${error.message}`);
      }
    }
  };

  return (
    <div>
      <button
        onClick={generarCertificado}
        className="bg-green-600 hover:bg-green-700 text-white p-3 rounded-lg font-bold flex items-center font-montserrat transition-all duration-300 ease-in-out hover:scale-105"
      >
        <img src={Descargar} alt="Icono de descarga" className="w-6 h-auto " />
        Descargar constancia
      </button>
      {error && <p>{error}</p>}
    </div>
  );
};

export default GenerarCertificado;
